<template>
  <b-container class="chart">
    <b-row>
      <div class="col-sm-12 col-md-12 col-lg-8 story map-emoji-chart">
        <vue-plotly
          v-if="chartData"
          :data="chartData"
          :layout="layout"
          class="chart"
        />

        <div class="emoji-scale">
          <div>
            OZG-Leistungen, die momentan mindestens Reifegrad {{ value }}
            <OZGLevelEmoji :level="parseInt(value)" /> erfüllen.
          </div>
          <input class="slider" v-model="value" type="range" min="0" max="4" />
        </div>
      </div> </b-row></b-container
></template>

<script>
import VuePlotly from "@statnett/vue-plotly";
import OZGLevelEmoji from "./OZGLevelEmoji";

export default {
  name: "OZGCountyMap",
  components: { OZGLevelEmoji, VuePlotly },
  apollo: {
    $client: "ozgClient",
    aggregateOnImplementationStatusByLeadingCounty: {
      query() {
        return require("../graphql/ozgServiceImplementationStatusByLeadingCounty.gql");
      }
    }
  },
  data: function() {
    return {
      value: 0,
      aggregateOnImplementationStatusByLeadingCounty: null,
      chartData: [],
      layout: {
        mapbox: {
          style: "stamen-toner",
          center: { lon: 10.01, lat: 51.15 },
          zoom: 5
        },
        height: 700
      }
    };
  },
  methods: {
    renderGraph: function(newVal) {
      {
        var counties = [
          "Baden-Württemberg",
          "Bayern",
          "Berlin",
          "Brandenburg",
          "Bremen",
          "Hamburg",
          "Hessen",
          "Mecklenburg-Vorpommern",
          "Niedersachsen",
          "Nordrhein-Westfalen",
          "Rheinland-Pfalz",
          "Saarland",
          "Sachsen-Anhalt",
          "Sachsen",
          "Schleswig-Holstein",
          "Thüringen"
        ];
        var aggregation = {
          type: "choroplethmapbox",
          name: "",
          geojson: require("../assets/german_counties.geo.json"),
          hovertemplate:
            "%{text.county} <b>%{z}</b>/%{text.sum} <br>Keine Informationen 🤔: %{text.no_information}",
          text: [
            { county: "Baden-Württemberg", sum: 0, no_information: 0 },
            { county: "Bayern", sum: 0, no_information: 0 },
            { county: "Berlin", sum: 0, no_information: 0 },
            { county: "Brandenburg", sum: 0, no_information: 0 },
            { county: "Bremen", sum: 0, no_information: 0 },
            { county: "Hamburg", sum: 0, no_information: 0 },
            { county: "Hessen", sum: 0, no_information: 0 },
            { county: "Mecklenburg-Vorpommern", sum: 0, no_information: 0 },
            { county: "Niedersachsen", sum: 0, no_information: 0 },
            { county: "Nordrhein-Westfalen", sum: 0, no_information: 0 },
            { county: "Rheinland-Pfalz", sum: 0, no_information: 0 },
            { county: "Saarland", sum: 0, no_information: 0 },
            { county: "Sachsen-Anhalt", sum: 0, no_information: 0 },
            { county: "Sachsen", sum: 0, no_information: 0 },
            { county: "Schleswig-Holstein", sum: 0, no_information: 0 },
            { county: "Thüringen", sum: 0, no_information: 0 }
          ],
          locations: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
          z: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          zmin: 0,
          zmax: 50,
          colorscale: [
            [0, "rgb(0,68,27)"],
            [0.125, "rgb(0,109,44)"],
            [0.25, "rgb(35,139,69)"],
            [0.375, "rgb(65,171,93)"],
            [0.5, "rgb(116,196,118)"],
            [0.625, "rgb(161,217,155)"],
            [0.8, "rgb(199,233,192)"],
            [0.95, "rgb(229,245,224)"],
            [1, "rgb(255,255,255)"]
          ],
          reversescale: true,

          colorbar: {
            y: 0,
            yanchor: "bottom",
            title: { text: "", side: "right" }
          }
        };

        for (var x in newVal) {
          if (newVal[x].implementationStatus > this.value) {
            aggregation.z[counties.indexOf(newVal[x].county.name)] +=
              newVal[x].count;
          }
          if (newVal[x].implementationStatus == null) {
            aggregation.text[
              counties.indexOf(newVal[x].county.name)
            ].no_information += newVal[x].count;
          } else {
            aggregation.text[counties.indexOf(newVal[x].county.name)].sum +=
              newVal[x].count;
          }
        }

        this.chartData = [aggregation];
      }
    }
  },
  watch: {
    aggregateOnImplementationStatusByLeadingCounty: function(newVal) {
      this.renderGraph(newVal);
    },
    value: function() {
      this.renderGraph(this.aggregateOnImplementationStatusByLeadingCounty);
    }
  }
};
</script>

<style scoped>
.slider {
  -webkit-appearance: none; /* Override default CSS styles */
  appearance: none;
  width: 80%; /* Full-width */
  height: 5px; /* Specified height */
  background: #111; /* Grey background */
  outline: none; /* Remove outline */
  opacity: 0.7; /* Set transparency (for mouse-over effects on hover) */
  -webkit-transition: 0.2s; /* 0.2 seconds transition on hover */
  transition: opacity 0.2s;
  border: 0px;
}

/* Mouse-over effects */
.slider:hover {
  opacity: 1; /* Fully shown on mouse-over */
}

/* The slider handle (use -webkit- (Chrome, Opera, Safari, Edge) and -moz- (Firefox) to override default look) */
.slider::-webkit-slider-thumb {
  -webkit-appearance: none; /* Override default look */
  appearance: none;
  width: 25px; /* Set a specific slider handle width */
  height: 25px; /* Slider handle height */
  background: #111; /* Green background */
  cursor: pointer; /* Cursor on hover */
}

.slider::-moz-range-thumb {
  width: 25px; /* Set a specific slider handle width */
  height: 25px; /* Slider handle height */
  background: #111; /* Green background */
  cursor: pointer; /* Cursor on hover */
}
.slider::-webkit-slider-thumb {
  background: #111;
  border: 0;
}

.slider::-moz-range-thumb {
  background: #111;
  border: 0;
}

.slider::-ms-thumb {
  background: #111;
  border: 0;
}
.emoji-scale {
  text-align: center;
}
.map-emoji-chart {
  padding-bottom: 30px;
}
</style>
